import { Label } from "@loot-os/ui/components/label";
import type { ReactNode } from "react";

/**
 * One labelled control in a filter grid; `id` names the control the label points at. `inline`
 * puts the label beside the control, as the Retool apps the fulfillment pages replace lay theirs:
 * `"aligned"` in a fixed column, so a stack of fields lines up, `"compact"` only as wide as the
 * label, for a row of them.
 */
export function FilterField({
  id,
  label,
  className,
  inline,
  children,
}: {
  id: string;
  label: string;
  className?: string;
  inline?: "aligned" | "compact";
  children: ReactNode;
}) {
  const layout =
    inline === "aligned"
      ? "grid grid-cols-[8.5rem_minmax(0,1fr)] items-center gap-2"
      : inline === "compact"
        ? "grid grid-cols-[auto_minmax(0,1fr)] items-center gap-2"
        : "grid gap-2";
  return (
    <div className={[layout, className].filter(Boolean).join(" ")}>
      <Label htmlFor={id} className={inline ? "font-semibold whitespace-nowrap" : undefined}>
        {label}
      </Label>
      {children}
    </div>
  );
}
